var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rest',{attrs:{"remote":_vm.remote,"table-columns":_vm.tableColumns,"formInitialize":_vm.formInitialize,"form-rules":_vm.formRules,"exportable":true,"export-visible":true,"use-drawer":true,"drawer-width":"50%","create-able":true,"update-able":true,"delete-able":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }